import { Box, Flex, Image, Text, useDisclosure } from "@chakra-ui/react";
import { useBgHover } from "../../../themes/colors";
import ResellersModal from "../../product_page/ResellersModal";

interface SimpleProductCardPropsType {
  imageSrc: string;
  name: string;
  lowestPrice: string;
  slug: string;
}

const SimpleProductCard = ({
  imageSrc,
  name,
  lowestPrice,
  slug,
}: SimpleProductCardPropsType) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgHover = useBgHover();

  return (
    <>
      <Flex
        flexDir={"column"}
        alignItems="center"
        gap={{ base: "8px", xl: "8px" }}
        cursor={"pointer"}
        onClick={onOpen}
        flex={"none"}
        flexShrink={0}
        flexGrow={0}
        w={"full"}
        p={2}
        borderRadius={["md", null, "lg"]}
        _hover={{ bg: bgHover }}
      >
        <Image
          className="ratio-1-1"
          w={"100%"}
          src={imageSrc}
          fallbackSrc="/assets/svg/illustration_empty.svg"
          alt={name}
          objectFit="cover"
          aspectRatio={1.5 / 1}
          borderRadius={"md"}
        />

        <Box textAlign={"center"} flex={1}>
          <Text
            textAlign={{ base: "center", xl: "left" }}
            textStyle={"h-subtitle"}
            fontWeight={"semibold"}
            noOfLines={1}
            w={"fit-content"}
          >
            {name}
          </Text>

          <Text
            textStyle={"b-sm-sb"}
            w={{ base: "fit-content", xl: "auto" }}
            mx={"auto"}
          >
            {lowestPrice}
          </Text>
        </Box>
      </Flex>

      <ResellersModal onClose={onClose} isOpen={isOpen} productSlug={slug} />
    </>
  );
};

export default SimpleProductCard;
